import { AUTHORIZATION_HEADER } from '../../../src/authorization';
import { send } from '../../../src/network';

interface CancelSubReason {
  id: number;
  cancel_reason_id: number;
  create_date: string;
  modify_date: string;
  name: string;
  is_active: boolean;
  followup: string;
}

export type GetCancelSubreasonsResponse = CancelSubReason[];

export function getCancelSubreasons(data: { cancelReason: number }) {
  const query = new URLSearchParams();
  query.set('cancelReason', data.cancelReason.toString());
  return send<GetCancelSubreasonsResponse>({
    path: '/api/get_cancel_subreasons/',
    method: 'GET',
    query,
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });
}
